import React, { useState } from "react";
import DirectorRegistrarSignature from "components/CompanyDashboard/MaintainYourCompany/Changes/SharedComponents/DocumentSignature/DirectorRegistrarSignature";
import _get from "lodash/get";

const SignatureDocuments = ({
  selectedTab,
  documentData,
  documentType,
  transactions,
  actionType,
}) => {
  const [singeDocPayload, setSingeDocPayload] = useState([]);

  // Destructure the first transaction from the array
  const transaction = transactions[0];

  // Create mockRow using the transaction data
  const mockRow = {
    original: {
      companyId: transaction.companyId,
      officialId: transaction.officialId,
      trxRef: transaction.trxRef,
      status: transaction.status,
      uploadChangeDocuments: transaction.uploadChangeDocuments || {
        fileUploads: {},
      },
      uploadDirectorApprovalDocs: transaction.uploadDirectorApprovalDocs || {
        fileUploads: {},
      },
      orgAdminReview: transaction.orgAdminReview || { fileUploads: [] },
      company: transaction.company,
      _id: transaction._id,
    },
  };

  return (
    <>
      <div className="mt-6 w-full bg-white overflow-x-auto">
        <DirectorRegistrarSignature
          row={mockRow}
          setSingeDocPayload={setSingeDocPayload}
        />
      </div>
    </>
  );
};

export default SignatureDocuments;
